export const clasificadorDeCreditos = (creditos, categoria) =>creditos.filter((creditos) => categoria.some((solicitudes) => solicitudes.id === creditos.id));
